// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__I1RHq","label":"Completed_label__2Gfne"};